module.exports = __webpack_public_path__ + "static/img/idcard-front.8e740597.png";